<template>
    <div class="service-wrap pt-20 pb-20">
        <div class="container">
            <!-- TABLEAU COLLOQUES / SÉMINAIRES -->
            <div class="row mb-5">
              <div class="col-12">
                <!-- <h3 class="mb-2">Colloques / Séminaires</h3> -->
                <p class="mb-3">
                    L’EITP dispose d’un fonds documentaire accessible. La Bibliothèque offre divers services à ses usagers.
                </p>
                
              </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">

import ApiService from "@/services/ApiService";
import { getUrlApiForFiles, error,format_Date } from "@/utils/utils";
import { defineComponent, ref, onMounted, computed } from "vue";
import { Article } from "@/models/Article";


export default defineComponent({
    name: 'DiesAcademicus',
    components: {
     

  },
  setup(){

    const articles = ref<Array<Article>>([]);   

        // BEGIN PAGINATE
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);

    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getTreeArticle(page_, limit_);
      } catch (error) {
        //
      }
    };

    function rechercher(){
        getTreeArticle(page.value, limit.value, searchTerm.value );
    }

    // END PAGINATE

    function getTreeArticle(page = 1, limi = 9, searchTerm = '') {
      return ApiService.get(`/actualite/articles/41?page=${page}&limit=${limi}&mot=${searchTerm}&`)
      
      .then(({ data }) => {
        articles.value = data.data.data;
        console.log("fff",articles.value)
        totalPages.value = data.data.totalPages;
        limit.value = data.data.limit;
        totalElements.value = data.data.totalElements;
      })
      .catch(({ response }) => {
        error(response.data.message)
      });
    } 

    const truncatedArticles = computed(() => {
        const maxLength = 100; 
        return articles.value.map(article => {
            if (article.titre.length > maxLength) {
            return {
                ...article,
                titre: article.titre.substring(0, maxLength) + '...'
            };
            }
            return article;
        });
    });

    // function getTreeArticle() {
    //   return ApiService.get(`/actualite/articles/22`)
    //     .then(({ data }) => {
    //       articles.value = data.data.data;
    //       console.log(articles.value);
    //       return data.data;
    //     })
    //     .catch(({ response }) => {
    //       error(response.message)
    //   });
    // }
    const axes = ref([
  {
    title: 'Foi et Vie',
    icon: 'flaticon-cross',
    description:
      'Études sur les défis théologico-pastoraux ; présentation, réception et diffusion des documents ecclésiaux ou magistériels.'
  },
  {
    title: 'Foi et Culture',
    icon: 'flaticon-open-book',
    description:
      'Recherches sur les modalités et moyens pour que la Parole de Dieu inspire une nouvelle culture et la création d’œuvres littéraires et artistiques.'
  },
  {
    title: 'Foi et Mémoire',
    icon: 'flaticon-history',
    description:
      'Études sur les faits historiques et la gestion de l’histoire de nos sociétés et de nos Églises : constitution, purification et promotion.'
  },
  {
    title: 'Foi et Politique',
    icon: 'flaticon-team',
    description:
      'Réflexions sur les implications sociopolitiques de l’Évangile et l’engagement chrétien.'
  }
]);

    onMounted(() => {
        getTreeArticle();
    });

    return { 
        axes,
        articles,
        getUrlApiForFiles,
        format_Date,
        page, 
        totalPages,
        limit,
        totalElements,
        handlePaginate,
        truncatedArticles
    };
  },
});
</script>

<style scoped>
    .blog-card .blog-info h3 {
        font-size: 20px;
        line-height: 30px;
        margin-bottom: 15px;
    }
    .section-title {
  font-size: 32px;
  font-weight: 700;
}

.section-subtitle {
  color: #ffc107;
  max-width: 700px;
  margin: 0 auto;
}

.axe-card {
  background: #fff;
  padding: 30px 25px;
  border-radius: 12px;
  height: 100%;
  text-align: center;
  transition: all 0.3s ease;
  box-shadow: 0 4px 10px #ad995c;
}

.axe-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.12);
}

.axe-icon {
  width: 70px;
  height: 70px;
  margin: 0 auto 20px;
  border-radius: 50%;
  background: #014c80;
  display: flex;
  align-items: center;
  justify-content: center;
}

.axe-icon i {
  font-size: 30px;
  color: #0d6efd;
}

.axe-card h4 {
  font-size: 20px;
  margin-bottom: 15px;
  font-weight: 600;
}

.axe-card p {
  font-size: 15px;
  color: #555;
  line-height: 1.7;
}

.btn-download {
  background-color: #ffc107;
  color: #0b1b3f;
  font-weight: 700;
  padding: 12px 25px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-download:hover {
  background-color: #e0a800;
  transform: translateY(-2px);
}

</style>